import { TabsItem } from 'types/tabsItem'

export const SUCCESS_STORIES_TAB: TabsItem = {
  id: 'success-stories',
  title: 'Success Stories',
}

export const STUDY_GUIDE_TAB: TabsItem = {
  id: 'study-guides',
  title: 'Study Guides',
}

export const TABS = [SUCCESS_STORIES_TAB, STUDY_GUIDE_TAB]

export const QUERY_PARAM = 'tab'

export const SUCCESS_STORIES_SUB_TAB_QUERY_PARAM = 'successStoriesView'
export const STUDY_GUIDES_SUB_TAB_QUERY_PARAM = 'studyGuidesView'

export const SUCCESS_STORY_SECTIONS_TAB: TabsItem = {
  id: 'sections',
  title: 'Success Stories Sections',
}

export const ALL_SUCCESS_STORIES_SUB_TAB: TabsItem = {
  id: 'all',
  title: 'All Success Stories',
}

export const SUCCESS_STORIES_SUB_TABS = [SUCCESS_STORY_SECTIONS_TAB, ALL_SUCCESS_STORIES_SUB_TAB]

export const STUDY_GUIDE_SECTIONS_TAB: TabsItem = {
  id: 'sections',
  title: 'Study Guide Sections',
}

export const ALL_STUDY_GUIDES_SUB_TAB: TabsItem = {
  id: 'all',
  title: 'All Study Guides',
}

export const STUDY_GUIDES_SUB_TABS = [STUDY_GUIDE_SECTIONS_TAB, ALL_STUDY_GUIDES_SUB_TAB]
